import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
    public transform(value: number): string {
        if (typeof value !== 'number') return '';
        return new Intl.NumberFormat('ru-UA').format(value);
    }
}
